import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

import TableHeadComponent from "../../../../common/TableHeadComponent";
import { QCTemplatesTableHeadCells, routes } from "../../../../constants";
import { useAuth } from "../../../../hooks";
import { useGetQCTemplates } from "../../hooks/QCTemplatesHooks";
import QCTableRowSection from "../QCTableRowSection/QCTableRowSection";

/**
 * QuickConnect tab on the Email Templates screen.
 *
 * Lists the org QuickConnect templates, falling back to the shared `default`
 * document when the org has none. There is deliberately no Create Template
 * button here yet; the table exists so more templates can be added later.
 *
 * See docs/QUICKCOLLECT_IMPLEMENTATION.md
 */
const QCTemplatesPanel = () => {
  const navigate = useNavigate();
  const { organizationId } = useAuth();
  const { templates, loading } = useGetQCTemplates(organizationId);

  const handleRowClick = (row) => {
    navigate(
      routes.qcTemplateDetails.replace(":templateId", row.id),
      { state: { isDefault: !!row.isDefault } }
    );
  };

  return (
    <Box>
      <Box sx={{ height: 6 }} />
      <Paper sx={{ width: "100%", mb: 2, mx: 2 }}>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-labelledby="qcTableTitle" size="medium">
            <TableHeadComponent
              TableHeadData={QCTemplatesTableHeadCells}
              numSelected={0}
              order="desc"
              orderBy="updatedAt"
              onSelectAllClick={() => {}}
              onRequestSort={() => {}}
              rowCount={templates.length}
              detailsPageReports={true}
            />
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ py: 5 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : templates.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={4}
                    align="center"
                    sx={{
                      py: 5,
                      fontFamily: "Avenir Book, sans-serif",
                      color: "#595959",
                    }}
                  >
                    No QuickConnect templates available.
                  </TableCell>
                </TableRow>
              ) : (
                templates.map((row, index) => (
                  <QCTableRowSection
                    key={row.id}
                    row={row}
                    labelId={`qc-template-${index}`}
                    handleRowClick={handleRowClick}
                  />
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default QCTemplatesPanel;
